import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Text from 'components/common/Text/Text'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'

const BOTSkuFindLowerPriceInfo = ({
  skuInformation: { price, tireSize, tireLineName }
}) =>
  <Wrapper>
    <Price data-at-modal-find-lower-price>
      { price }
    </Price>
    <TireInformation>
      <Text data-at-modal-find-lower-price-tire-name size={ 16 } block bold uppercase>{ tireLineName }</Text>
      <Text data-at-modal-find-lower-price-tire-size size={ 16 } block uppercase>{ tireSize }</Text>
    </TireInformation>
  </Wrapper>

BOTSkuFindLowerPriceInfo.propTypes = {
  skuInformation: PropTypes.shape({
    price: PropTypes.string,
    tireSize: PropTypes.string,
    tireLineName: PropTypes.string
  })
}

export default BOTSkuFindLowerPriceInfo

const Price = styled.div`
  ${Mixin.responsive('display', 'inline-block', 'block')};
  margin-right: 32px;
  vertical-align: middle;
  font-size: 32px;
  font-weight: 700;
  color: ${Theme.colors.red};
`

const TireInformation = styled.div`
  ${Mixin.responsive('display', 'inline-block', 'block')};
  vertical-align: middle;
`

const Wrapper = styled.div`
  margin-bottom: 32px;
`
